<!-- Transparent backdrop to block page interactions when busy -->
<div class="page-blocker" *ngIf="showDialog && busy"></div>

<div
    #aiDialog
    *ngIf="showDialog"
    [@dialogAnim]="{ value: '', params: { startTransform: dialogStartTransform } }"
    class="modeless-dialog"
    [class.is-busy]="busy"
    cdkDrag
    cdkDragBoundary="body"
    [ngStyle]="{
    top: dialogState.top + 'px',
    left: dialogState.left + 'px',
    width: dialogState.width + 'px',
    height: dialogState.height + 'px'
    }"
    (cdkDragEnded)="onDragEnded($event)">
    <div class="dialog-header" cdkDragHandle (dblclick)="hideDialog()">
        <div class="header-left">
            <svg class="ai-icon" width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <linearGradient id="ai-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" style="stop-color:#4A90E2;stop-opacity:1" />
                        <stop offset="100%" style="stop-color:#357ABD;stop-opacity:1" />
                    </linearGradient>
                </defs>
                <path d="M12 2 L20 7 L20 17 L12 22 L4 17 L4 7 Z" fill="url(#ai-gradient)" stroke="#2C5AA0" stroke-width="1"/>
                <text x="12" y="16" font-family="Arial, sans-serif" font-size="10" font-weight="bold" text-anchor="middle" fill="white">AI</text>
            </svg>
            <h2 class="title">{{ title }}</h2>
        </div>

        <div class="header-center">
            <div class="balance-container">
                <span class="balance-label">Balance</span>
                <span class="balance-amount">${{balance}}</span>
                <button mat-icon-button class="add-money-btn" (click)="addMoney();" title="Add funds" [disabled]="busy">
                    <mat-icon>add_circle_outline</mat-icon>
                </button>
            </div>
        </div>

        <div class="header-actions">
            <button mat-icon-button (click)="saveJson();" title="Copy scene snapshot" [disabled]="busy">
                <mat-icon>content_copy</mat-icon>
            </button>

            <button mat-icon-button (click)="showJson('saved', 'saved');" title="View saved" [disabled]="busy">
                <mat-icon>visibility</mat-icon>
            </button>

            <button mat-icon-button (click)="showJson(aiService.newSceneData, aiService.newSceneData);" title="View new scene" [disabled]="busy">
                <mat-icon>visibility</mat-icon>
            </button>

            <button mat-icon-button (click)="showJson('saved', aiService.newSceneData);" title="Compare with snapshot" [disabled]="busy">
                <mat-icon>difference</mat-icon>
            </button>


            <button mat-icon-button (click)="cleanView();" title="Clear conversation" [disabled]="busy">
                <mat-icon>clear_all</mat-icon>
            </button>
            <button mat-icon-button (click)="settings();" title="Settings" [disabled]="busy">
                <mat-icon>settings</mat-icon>
            </button>
            <button mat-icon-button (click)="hideDialog();" title="Minimize" [disabled]="busy">
                <mat-icon>minimize</mat-icon>
            </button>
        </div>
    </div>

    <div #textArea class="dialog-content" [innerHTML]="dialogHtml | pipeSafe:'html'"></div>

    <!-- Busy indicator overlay -->
    <div class="busy-indicator" *ngIf="busy">
        <div class="busy-content">
            <div class="ai-thinking">
                <span class="thinking-dot"></span>
                <span class="thinking-dot"></span>
                <span class="thinking-dot"></span>
            </div>
            <span class="busy-text">AI is thinking... <span class="escape-hint">(ESC to interrupt)</span></span>
        </div>
    </div>

    <div class="dialog-actions">
        <input
            #promptInput
            type="text"
            [(ngModel)]="prompt"
            [disabled]="busy"
            placeholder="Enter your prompt"
            (keyup.enter)="!busy && onSend()"
        />

        <button mat-icon-button (click)="toggleListening()" [color]="isListening ? 'warn' : 'primary'" [disabled]="busy">
            <mat-icon>{{ isListening ? 'mic' : 'mic_none' }}</mat-icon>
        </button>

        <button mat-icon-button color="primary" [attr.aria-label]="busy ? 'Stop' : 'Send prompt'" (click)="busy ? onStop() : onSend()" [disabled]="!busy && !prompt.trim()">
            <mat-icon>{{ busy ? 'stop' : 'send' }}</mat-icon>
        </button>


    </div>

    <!-- Resize handle - only in bottom-right corner -->
    <div class="resize-grip" (mousedown)="startResize($event, 'bottom-right')"></div>
</div>



